import PropTypes from 'prop-types';
import React from 'react';
import { OlsConfigStore } from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';

const YotpoCSS = ({ products }) => {
  const { app_key: appKey } = OlsConfigStore.getState().yotpo_config || {};
  if (!appKey || !products || !products.length) {
    return null;
  }

  return (
    <style
      dangerouslySetInnerHTML={{
        __html: `
          .ratings-review-wrapper.product-list .yotpo-bottomline a {
            display: none;
          }
          .ratings-review-wrapper.product-list .yotpo-bottomline.pull-left {
            text-align: inherit;
            float: inherit;
          }
          .ratings-review-wrapper.product-list .yotpo-stars .yotpo-icon {
              font-size: 15.5px;
          }
        `
      }}
    />
  );
};

YotpoCSS.propTypes = {
  products: PropTypes.array
};

export default YotpoCSS;
